import {
  createMessageShort,
  InitializeChat,
  joinUserChat,
  updatePendingChats,
  AssignChat,
  createNewMessageByChat,
} from "../../graphql/myMutations";
import {
  getChatsByUserId,
  getMessagesByChat,
  getUserOfaChat,
  messageByCreationDate,
  getChatById,
  ListChatsByUser,
  ListMessagesByChat,
} from "../../graphql/myQueries";
import {
  onCreateMessage,
  onCreateMessageByChatId,
} from "../../graphql/subscriptions";
import { getOne, createOne, get, subscribe } from "../../Provider";

// Query
export async function chatIsActiveService(id) {
  return get(getChatById, { id });
}

export async function getChatsByUserIdService(id) {
  return get(ListChatsByUser, { id });
}

export async function getMessagesByChatService(chat_id) {
  return get(ListMessagesByChat, { chat_id });
}

export async function getUserOfaChatService(chat_id) {
  return getOne(getUserOfaChat, { chat_id });
}

export async function messageByCreationDateService(chat_id) {
  return getOne(messageByCreationDate, { chat_id });
}

// Mutations
export async function createNewChatService(input) {
  return createOne(InitializeChat, { input });
}

export async function AssignChatService(input) {
  return createOne(AssignChat, { input });
}

export async function createNewMessageByChatService(input) {
  return createOne(createNewMessageByChat, { input });
}

export async function updatePendingChatsService(input) {
  return createOne(updatePendingChats, { input });
}

// Subscriptions
export async function onCreateMessageByChatIdService(chat_id) {
  return subscribe(onCreateMessageByChatId, { chat_id });
}

export async function onCreateMessageService(id) {
  return subscribe(onCreateMessage, { id });
}
